import getCharts from '../getCharts'
import { GetDiagnosis } from '../../constants/api.config'

export default async function GetDiagnosisData(name = "") {
  try {
    const payload = { name }
    const res = await getCharts(GetDiagnosis, payload)
    return res.data
  } catch (error) {
    return error
  }
}
